var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#41FFD1;}\n\t.st1{fill:none;stroke:#2A0760;stroke-width:30;stroke-miterlimit:10;}\n\t.st2{fill:#2A0760;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 540,
    cy: 540,
    r: 430.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ikon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.2,353.3h209.6c4.8,0,8.8,3.9,8.8,8.8V718c0,4.8-3.9,8.8-8.8,8.8H435.2c-4.8,0-8.8-3.9-8.8-8.8V362 C426.4,357.2,430.3,353.3,435.2,353.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,688.2c-4.6,0-9.1-1.9-12.4-5.1c-0.4-0.4-0.8-0.8-1.2-1.3c-0.4-0.4-0.7-0.9-1-1.4c-0.3-0.5-0.6-1-0.9-1.5 c-0.3-0.5-0.5-1-0.7-1.5c-0.2-0.5-0.4-1.1-0.6-1.6c-0.2-0.5-0.3-1.1-0.4-1.7c-0.1-0.6-0.2-1.1-0.3-1.7c0-0.6-0.1-1.2-0.1-1.7 s0-1.2,0.1-1.7c0.1-0.6,0.1-1.1,0.3-1.7c0.1-0.6,0.3-1.1,0.4-1.7c0.2-0.5,0.4-1.1,0.6-1.6c0.2-0.5,0.4-1,0.7-1.5 c0.3-0.5,0.6-1,0.9-1.5c0.3-0.5,0.6-0.9,1-1.4c0.4-0.5,0.8-0.9,1.2-1.3s0.8-0.8,1.3-1.2c0.4-0.4,0.9-0.7,1.4-1 c0.5-0.3,1-0.6,1.5-0.9s1-0.5,1.6-0.7s1.1-0.4,1.6-0.6s1.1-0.3,1.7-0.4s1.1-0.2,1.7-0.2c1.1-0.1,2.3-0.1,3.5,0 c0.6,0.1,1.1,0.2,1.7,0.2s1.1,0.3,1.7,0.4s1.1,0.4,1.6,0.6s1,0.5,1.6,0.7c0.5,0.3,1,0.6,1.5,0.9c0.5,0.3,0.9,0.6,1.4,1 c0.4,0.4,0.9,0.8,1.3,1.2s0.8,0.8,1.2,1.3c0.4,0.4,0.7,0.9,1,1.4c0.3,0.5,0.6,1,0.9,1.5c0.3,0.5,0.5,1,0.7,1.5 c0.2,0.5,0.4,1.1,0.6,1.6c0.3,1.1,0.6,2.2,0.7,3.4c0.1,0.6,0.1,1.2,0.1,1.7c0,1.1-0.1,2.3-0.3,3.4c-0.1,0.6-0.2,1.1-0.4,1.7 c-0.2,0.5-0.4,1.1-0.6,1.6s-0.5,1-0.7,1.5c-0.5,1-1.2,2-1.9,2.9c-0.4,0.4-0.8,0.9-1.2,1.3C549.1,686.3,544.6,688.2,540,688.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileGreen);
export default __webpack_public_path__ + "static/media/MobileGreen.80bc562e.svg";
export { ForwardRef as ReactComponent };